import React, { useState, useEffect } from 'react';

import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import { RiCollapseDiagonalLine } from "react-icons/ri";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import { FaArrowLeftLong } from "react-icons/fa6";
import { FaFilter } from "react-icons/fa";
import { TbReload } from "react-icons/tb";
import { TbArrowsSort } from "react-icons/tb";
import { MdOutlineAdd } from "react-icons/md";
import { LuSquareArrowOutUpRight } from "react-icons/lu";
import { HiCheckCircle } from "react-icons/hi";
import InsightsModal from './InsightsModal';
import { FaBullhorn } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaWifi } from "react-icons/fa";
import { MdOutlineSignalCellularConnectedNoInternet4Bar } from "react-icons/md";
import { MdBatteryFull } from "react-icons/md";
import { FaShop } from "react-icons/fa6";
import { RxDotsVertical } from "react-icons/rx";
import { CiFaceSmile } from "react-icons/ci";
import { FaPaperclip } from "react-icons/fa";
import { FaCamera } from "react-icons/fa";
import { FaMicrophone } from "react-icons/fa";
import { MdRemoveRedEye } from "react-icons/md";
import { FaCopy } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { FaCogs } from "react-icons/fa";
import { PiSignInBold } from "react-icons/pi";
import { FiEdit } from "react-icons/fi";
import { FaPaperPlane } from "react-icons/fa";
import { LuRefreshCcw } from "react-icons/lu";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

import whatsappnotch from '../images/Wp-notch-image.png'
import Whatsappicon from '../images/Whatsappicon.png'
import whatsappBgimage from '../images/whatsapp-mobile-image.png'
import whatsappBodyBgimage from '../images/whatsappBackground.jpg'
import ApiPayloadModal from './Apipayload';
import TemplatePreview from './templatePreview';
import CampaignModal from './campaignModal';
import SyncModal from './SyncModal';
import DeleteModal from './DeleteModal';

function decodeToken(token) {
    if (!token) return {};
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map(function (c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                })
                .join('')
        );
        return JSON.parse(jsonPayload);
    } catch (e) {
        return {};
    }
}

function getUserIdFromTokenOrLocatorgarsotrga() {
    if (typeof window !== 'undefined' && typeof window.locatorgarsotrga === 'function') {
        const rawToken = window.locatorgarsotrga("token");
        if (rawToken) {
            const decoded = decodeToken(rawToken);
            const userId = decoded.id || decoded.userId || decoded._id;
            return { userId, token: rawToken };
        }
    }
    const rawToken = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
    if (rawToken) {
        const decoded = decodeToken(rawToken);
        const userId = decoded.id || decoded.userId || decoded._id;
        return { userId, token: rawToken };
    }
    return { userId: null, token: null };
}

function getFirstComponentText(template) {
    if (!template?.components) return "";
    const body = template.components.find(c => (c.type === "BODY" || c.type === "body") && c.text);
    if (body) return body.text;
    const anyText = template.components.find(c => c.text);
    return anyText?.text || "";
}

function getApiPayloadFromTemplate(template) {
    return {
        messaging_product: "whatsapp",
        recipient_type: "individual",
        to: "{{to}}",
        type: "template",
        template: {
            name: template.name,
            language: {
                code: template.language,
            },
            components: template.components
                ? template.components.map(comp => ({
                    type: comp.type,
                    parameters: comp.parameters || []
                }))
                : []
        },
        biz_opaque_callback_data: "{{BizOpaqueCallbackData}}"
    };
}

function formatDate(dt) {
    if (!dt) return '';
    try {
        const d = new Date(dt);
        if (!isNaN(d.getTime())) {
            return `${d.toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" })} ${d.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' })}`;
        }
        return dt;
    } catch (e) {
        return dt;
    }
}

// Pagination component (simple, styled, non-material)
function Pagination({ currentPage, pageCount, setPage }) {
    if (pageCount <= 1) return null;
    const pageRange = [];
    for (let i = 1; i <= pageCount; i++) {
        pageRange.push(i);
    }
    // Show ellipsis if more than 7 pages
    let pages = pageRange;
    if (pageCount > 7) {
        if (currentPage <= 4) {
            pages = [1,2,3,4,5,'...',pageCount];
        } else if (currentPage >= pageCount-3) {
            pages = [1,'...',pageCount-4,pageCount-3,pageCount-2,pageCount-1,pageCount];
        } else {
            pages = [1,'...',currentPage-1, currentPage, currentPage+1,'...', pageCount];
        }
    }
    return (
        <div className="flex justify-center items-center gap-1 mt-4 select-none">
            <button
                disabled={currentPage === 1}
                className={`px-3 py-1 rounded-lg border text-sm ${currentPage === 1 ? "bg-gray-200 text-gray-400 cursor-not-allowed" : "hover:bg-blue-100 text-gray-600"}`}
                onClick={() => setPage(1)}
            >{"<<"}</button>
            <button
                disabled={currentPage === 1}
                className={`px-3 py-1 rounded-lg border text-sm ${currentPage === 1 ? "bg-gray-200 text-gray-400 cursor-not-allowed" : "hover:bg-blue-100 text-gray-600"}`}
                onClick={() => setPage(currentPage-1)}
            >{"<"}</button>
            {pages.map((n,i) =>
                n === "..." ? (
                    <span key={"ellipsis-"+i} className="px-2 py-1 text-gray-400">...</span>
                ) : (
                    <button
                        key={n}
                        onClick={() => setPage(n)}
                        className={`px-3 py-1 rounded-lg border text-sm ${n===currentPage ? "bg-[#316bb0] text-white font-bold border-[#316bb0]" : "hover:bg-blue-100 text-gray-600"}`}>{n}</button>
                )
            )}
            <button
                disabled={currentPage === pageCount}
                className={`px-3 py-1 rounded-lg border text-sm ${currentPage === pageCount ? "bg-gray-200 text-gray-400 cursor-not-allowed" : "hover:bg-blue-100 text-gray-600"}`}
                onClick={() => setPage(currentPage+1)}
            >{">"}</button>
            <button
                disabled={currentPage === pageCount}
                className={`px-3 py-1 rounded-lg border text-sm ${currentPage === pageCount ? "bg-gray-200 text-gray-400 cursor-not-allowed" : "hover:bg-blue-100 text-gray-600"}`}
                onClick={() => setPage(pageCount)}
            >{">>"}</button>
        </div>
    )
}

function WhatsAppTemplates() {
    const [showfilter, setshowfilter] = useState(false);
    const [open, setopen] = useState(false);
    const [OpenApipayload, setOpenApipayload] = useState(false);
    const [openTemplatePreview, setopenTemplatePreview] = useState(false);
    const [openCampainModal, setopenCampainModal] = useState(false);
    const [openSyncModal, setopenSyncModal] = useState(false);
    const [openDeleteModal, setopenDeleteModal] = useState(false);
    const [syncProgress, setSyncProgress] = useState();
    // Data state
    const [waTemplates, setWaTemplates] = useState([]);
    const [waTemplatesLoading, setWaTemplatesLoading] = useState(false);
    const [waTemplatesError, setWaTemplatesError] = useState(null);
    const [Datatext, setDatatext] = useState('');
    const [Apipayload, setApipayload] = useState({});
    const [idfordelete, setidfordelete] = useState(null);
    const [showPicker, setShowPicker] = useState(false);
    const [Daterange, setDaterange] = useState('7');
    const [customLabel, setCustomLabel] = useState('Custom range');
    const [state, setState] = useState([
        { startDate: new Date(), endDate: new Date(), key: "selection" },
    ]);
    const [openDropdown, setOpenDropdown] = useState(false);
    const navigate = useNavigate();

    // Pagination State
    const [page, setPage] = useState(1);
    const [rowsPerPage] = useState(10);

    // API authentication and session
    const { userId, token } = getUserIdFromTokenOrLocatorgarsotrga();
    const [wabaIds, setWabaIds] = useState([]);
    const [wabaId, setWabaId] = useState("");
    const [accessToken, setAccessToken] = useState("");
    const[template_name, setTemplate_name] = useState("");

    // FILTER STATE
    // Add filter states for the input/selects in the filter row.
    const [filterName, setFilterName] = useState("");
    const [filterStatus, setFilterStatus] = useState("");
    const [filterCategory, setFilterCategory] = useState("");

    // 1. Fetch Meta access token for user
    async function fetchUserAccessToken(userId) {
        if (!userId) return null;
        try {
            const res = await fetch(
                `https://wa-api.globebot.io/auth/access_token?user_id=${encodeURIComponent(userId)}`
            );
            if (!res.ok) throw new Error("Error fetching access_token");
            const data = await res.json();
            if (Array.isArray(data.access_token) && data.access_token.length > 0) {
                return data.access_token[0];
            }
            return null;
        } catch {
            return null;
        }
    }

    // Fetch user's WABA ids
    useEffect(() => {
        if (!userId || !token) {
            setWabaIds([]);
            setWabaId("");
            return;
        }
        setWabaIds([]);
        setWabaId("");
        fetch(`https://wa-api.globebot.io/auth/whatsapp/waba_ids?user_id=${encodeURIComponent(userId)}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then(res => res.json())
        .then(data => {
            if (data && Array.isArray(data.waba_ids) && data.waba_ids.length > 0) {
                setWabaIds(data.waba_ids);
                setWabaId(data.waba_ids[0]);
            } else {
                setWabaIds([]);
                setWabaId("");
            }
        })
        .catch(() => {
            setWabaIds([]);
            setWabaId("");
        });
    }, [userId, token]);

    // Fetch Meta Access Token
    useEffect(() => {
        if (!userId) {
            setAccessToken("");
            return;
        }
        fetchUserAccessToken(userId).then(t => setAccessToken(t || ""));
    }, [userId]);

    // Fetch WhatsApp Templates using API
    useEffect(() => {
        if (!wabaId || !accessToken) {
            setWaTemplates([]);
            return;
        }
        setWaTemplatesLoading(true);
        setWaTemplatesError(null);
        fetch(
            `https://wa-api.globebot.io/auth/whatsapp/meta_templates/full?waba_id=${encodeURIComponent(wabaId)}&access_token=${encodeURIComponent(accessToken)}`
        )
            .then(res => res.json())
            .then(data => {
                if (Array.isArray(data)) {
                    setWaTemplates(data);
                } else {
                    setWaTemplates([]);
                    setWaTemplatesError("Failed to fetch WhatsApp templates.");
                }
                setWaTemplatesLoading(false);
            })
            .catch(() => {
                setWaTemplates([]);
                setWaTemplatesError("Failed to fetch WhatsApp templates.");
                setWaTemplatesLoading(false);
            });
    }, [wabaId, accessToken]);

    // Fixing the use of template_name by fetching business info from /whatsappbusiness/waba/:wabaId,
    // and setTemplate_name according to the response from the endpoint (see @authRoutes.ts lines 3311-3332)
    useEffect(() => {
        if (!wabaId) {
            setTemplate_name("");
            return;
        }

        fetch(`https://wa-api.globebot.io/auth/whatsappbusiness/waba/${encodeURIComponent(wabaId)}`)
            .then(res => res.json())
            .then(data => {
                if (data.success && data.business) {
                    setTemplate_name(data.business.business_name || "");
                } else {
                    setTemplate_name("");
                }
            })
            .catch(() => {
                setTemplate_name("");
            });
    }, [wabaId]);


    // Get Text for modal preview
    const getText = (id) => {
        const item = waTemplates.find(item => item.id === id);
        setDatatext(getFirstComponentText(item));
    };

    // Get API Payload from template
    const getApipayload = (id) => {
        const item = waTemplates.find(item => item.id === id);
        if (item) setApipayload(getApiPayloadFromTemplate(item));
        else setApipayload({});
    };

    // Copy API Payload to clipboard
    const handleCopy = () => {
        const text = JSON.stringify(Apipayload, null, 2);
        navigator.clipboard.writeText(text)
            .then(() => {
                // Optionally, notify user
            })
            .catch((err) => {
                // Optionally, error notification
            });
    };

    // Helper: get url/text for editing
    const getUrl = (id) => {
        const item = waTemplates.find(item => item.id === id);
        return getFirstComponentText(item) || "";
    };

    // Action: Go to edit page with text
    const handletext = (Url,tempname) => {
        navigate(`/WAMessage/WATemplate/AddEditTemplate?text=${encodeURIComponent(Url)}&name=${tempname}`);
    };

    // Delete a template (local UI only, no backend deletion)
    const Deleteitem = (id) => {
        setWaTemplates(prev => prev.filter(item => item.id !== id));
    };

    // Dummy for insights button clicks
    const data = [];

    // Filtering logic - PRIMARY FIX
    // We need to filter templates before pagination!
    function matchLike(str, q) {
        return (str || '').toLowerCase().includes((q || '').toLowerCase());
    }
    const filteredTemplates = waTemplates.filter(item => {
        // Name
        const nameMatch = filterName
            ? matchLike(item.name, filterName)
            : true;
        // Status
        const statusMatch = filterStatus
            ? (item.status && item.status.toLowerCase() === filterStatus.toLowerCase())
            : true;
        // Category
        // item.category is sometimes a name, sometimes a numeric code, so match as substring
        const cat = (item.category || '').toString().toLowerCase();
        const filterCat = filterCategory.toString().toLowerCase();
        const categoryMatch = filterCategory
            ? (cat === filterCat || cat.includes(filterCat))
            : true;
        return nameMatch && statusMatch && categoryMatch;
    });

    // Pagination calculation - USE FILTERED DATA
    const pageCount = Math.ceil(filteredTemplates.length / rowsPerPage) || 1;
    const pagedTemplates = filteredTemplates.slice((page-1) * rowsPerPage, page * rowsPerPage);

    // If filteredTemplates change, reset to page 1 if out of range
    useEffect(() => {
      if (page > pageCount) setPage(1);
    }, [filteredTemplates, page, pageCount]);

    async function retrieveMetaTemplates() {
        if (!wabaId || !accessToken) {
            alert("Missing WABA ID or access token!");
            return;
        }

        setSyncProgress({ visible: true, percent: 5, message: "Starting retrieval..." });

        try {
            setSyncProgress({ visible: true, percent: 15, message: "Connecting to Meta server..." });

            const fetchPromise = fetch(
                `https://wa-api.globebot.io/auth/whatsapp/meta_templates?waba_id=${encodeURIComponent(wabaId)}&access_token=${encodeURIComponent(accessToken)}`,
                { method: "GET" }
            );

            let percent = 15;
            const interval = setInterval(() => {
                percent += Math.floor(Math.random() * 8 + 5);
                if (percent >= 85) percent = 85;
                setSyncProgress(prev => ({ ...prev, percent, message: "Fetching templates..." }));
            }, 500);

            const response = await fetchPromise;

            clearInterval(interval);

            if (!response.ok) {
                const data = await response.json();
                setSyncProgress({ visible: false, percent: 0, message: "" });
                throw new Error(data?.error || "Failed to retrieve Meta templates");
            } else {
                setSyncProgress({ visible: true, percent: 95, message: "Updating local database..." });
                setTimeout(() => {
                    setSyncProgress({ visible: true, percent: 100, message: "Complete! Synchronized successfully." });
                    setTimeout(() => {
                        setSyncProgress({ visible: false, percent: 0, message: "" });
                        window.location.reload();
                    }, 1000);
                }, 500);
            }
        } catch (err) {
            setSyncProgress({ visible: false, percent: 0, message: "" });
            console.error("Error retrieving/syncing Meta WhatsApp Templates:", err);
            alert("Failed to retrieve Meta templates: " + err.message);
        }
    }

    // Render sync progress modal if active
    const renderSyncProgressModal = syncProgress?.visible && (
        <div style={{
            position: "fixed", left: 0, top: 0, width: "100vw", height: "100vh",
            background: "rgba(0,0,0,0.4)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999
        }}>
            <div style={{
                background: "#fff", borderRadius: 8, boxShadow: "0 4px 20px #0002", padding: 32, minWidth: 320,
                display: "flex", flexDirection: "column", alignItems: "center"
            }}>
                <div className="font-semibold text-lg mb-2" style={{ color: "#316bb0" }}>
                    Synchronizing Meta WhatsApp Templates...
                </div>
                <div style={{ width: "90%", height: 10, background: "#eee", borderRadius: 8, marginTop: 8, marginBottom: 8 }}>
                    <div style={{
                        width: `${syncProgress.percent}%`,
                        height: "100%",
                        background: "#316bb0",
                        borderRadius: 8,
                        transition: "width 0.4s",
                    }} />
                </div>
                <div style={{ fontSize: 14, color: "#555", margin: '8px 0' }}>
                    {syncProgress.percent}% {syncProgress.message}
                </div>
            </div>
        </div>
    );

    return (
        <>
         {renderSyncProgressModal}
            <div className='px-2 dark:bg-[#121519] h-[100vh] pl-4'>
                <div className='border-b-[1px] border-[#cfcdcd] pb-1 '>
                    <h1 className='text-[#000] font-semibold text-[20px] dark:text-[#fff] flex items-center'>
                        <Link to='/configuration'><FaArrowLeftLong /> </Link>
                        WhatsApp Templates
                    </h1>
                    <div className='text-[#454546] dark:text-[#fff] text-[12px] font-semibold flex items-center cursor-pointer'>
                        <span>Home</span> <IoIosArrowForward /><span>Configuration</span><IoIosArrowForward />
                        <span>WABAChannels</span>
                    </div>
                </div>
                <div className='w-[100%] flex gap-2 mt-2'>
                    <Link to='/WAMessage/WATemplate/SetupTemplate'>
                        <button className='hover:bg-[#316bb0] border-[1px] border-[#316bb0] flex items-center text-[11px] hover:text-[#fff] text-[#316bb0] font-bold p-2 gap-1 rounded-[5px]'>
                            <MdOutlineAdd className='text-[14px]' />
                            Create New Template
                        </button>
                    </Link>
                    <button
                        className='bg-[#316bb0] border-[1px] border-[#316bb0] flex items-center text-[11px] text-[#fff]  font-bold p-2 gap-1 rounded-[5px]'
                        onClick={retrieveMetaTemplates}
                    >
                        <MdOutlineAdd className='text-[14px]' />
                        Retrieve Meta Templates
                    </button>
                </div>
                <div onClick={() => setshowfilter(!showfilter)}
                    className='w-[100%] flex justify-between  px-4 py-2 bg-[#e0e0e04b] rounded-t-[20px] mt-4'>
                    <div className='flex items-center text-[#576071] font-semibold gap-3 dark:text-[#fff] '>
                        <RiCollapseDiagonalLine />
                        Filter Records
                    </div>
                    <div className='flex items-center text-[#576071] font-semibold gap-3 dark:text-[#fff] '>
                        {showfilter ? <IoIosArrowDown /> : <IoIosArrowUp />}
                    </div>
                </div>
                {showfilter &&
                    <div className='bg-[#edf1f5] py-2 px-4 w-[100%] dark:bg-[#121519]'>
                        <div className='w-[100%] flex flex-wrap gap-4'>
                            <div className='w-full sm:w-[48%] md:w-[31%] lg:w-[24%] flex flex-col gap-1'>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>TemplateName :</label>
                                <input
                                    className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                    type="text"
                                    value={filterName}
                                    onChange={e => setFilterName(e.target.value)}
                                />
                            </div>
                            <div className='w-full sm:w-[48%] md:w-[31%] lg:w-[24%] flex flex-col gap-1'>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Template Status</label>
                                <select
                                  className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 dark:bg-[#121519] dark:text-[#fff]'
                                  value={filterStatus}
                                  onChange={e => setFilterStatus(e.target.value)}
                                >
                                    <option value="">Select Template Status</option>
                                    <option value="pending">Pending</option>
                                    <option value="approvED">Approved</option>
                                    <option value="rejected">Rejected</option>
                                </select>
                            </div>
                            <div className='w-full sm:w-[48%] md:w-[31%] lg:w-[24%] flex flex-col gap-1'>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Template Category</label>
                                <select
                                  className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 dark:bg-[#121519] dark:text-[#fff]'
                                  value={filterCategory}
                                  onChange={e => setFilterCategory(e.target.value)}
                                >
                                    <option value="">Select Template Category</option>
                                    <option value="Marketing">Marketing</option>
                                    <option value="Utility">Utility</option>
                                    <option value="Authentication">Authentication</option>
                                  
                                </select>
                            </div>
                            <div className='w-full sm:w-[48%] md:w-[31%] lg:w-[24%] flex items-center gap-1 mt-4'>
                                <button
                                    className='flex items-center justify-center border-[1px] border-[#37715d] rounded-lg p-2 text-[#37715d] gap-2 hover:bg-[#37715d] hover:text-[#fff] w-full sm:w-auto'
                                    onClick={e => { e.preventDefault(); setPage(1); }}
                                >
                                    <FaFilter /> <span className='text-[12px] font-bold'>Filter</span>
                                </button>
                                <button
                                    className='flex items-center justify-center border-[1px] border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-2 hover:bg-[#3f7fca] hover:text-[#fff] w-full sm:w-auto'
                                    onClick={e => {
                                        e.preventDefault();
                                        setFilterName("");
                                        setFilterStatus("");
                                        setFilterCategory("");
                                        setPage(1);
                                    }}
                                >
                                    <TbReload /> <span className='text-[12px] font-bold '>Clear Filter</span>
                                </button>
                            </div>
                        </div>
                    </div>
                }
                <table className="w-full   overflow-hidden border-[1px] border-[#dee2e6] ">
                    <thead>
                        <tr className="text-left text-sm font-semibold text-gray-700">
                            <th className="p-2 cursor-pointer border-[1px] border-[#dee2e6]">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Insights</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-2 cursor-pointer border-[1px] border-[#dee2e6]">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Name / Lang Code</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-2 cursor-pointer border-[1px] border-[#dee2e6]">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Text</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-2 cursor-pointer border-[1px] border-[#dee2e6]">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Category & Status</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-2 cursor-pointer border-[1px] border-[#dee2e6]">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Created / Modified</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-2 cursor-pointer border-[1px] border-[#dee2e6]">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>API Payload</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                            <th className="p-2 cursor-pointer border-[1px] border-[#dee2e6]">
                                <div className="flex justify-between items-center gap-2">
                                    <span className='text-[11px] text-[#576071] dark:text-[#fff]'>Actions</span>
                                    <button type="button" className="text-gray-500 hover:text-black">
                                        <TbArrowsSort />
                                    </button>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {waTemplatesLoading ? (
                            <tr>
                                <td colSpan={7} className="p-3 text-center text-gray-600 text-[13px]">
                                    Loading templates...
                                </td>
                            </tr>
                        ) : waTemplatesError ? (
                            <tr>
                                <td colSpan={7} className="p-3 text-center text-red-600 text-[13px]">
                                    {waTemplatesError}
                                </td>
                            </tr>
                        ) : filteredTemplates && filteredTemplates.length > 0 ? (
                            pagedTemplates.map((item, index) => (
                                <tr
                                    key={item.id || ((page-1)*rowsPerPage + index)}
                                    className="text-center text-gray-500 bg-[#f6f9fc] dark:bg-[#121519]"
                                >
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6]">
                                        <button
                                            onClick={() => {
                                                setopen(true);
                                                getText(item.id);
                                            }}
                                            className='bg-[#316bb0] p-1 rounded-md text-[#fff] flex items-center gap-1 text-[12px]'>
                                            <LuSquareArrowOutUpRight /> Insights
                                        </button>
                                    </td>
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] text-start">
                                        <p> <span className='text-[#000] font-bold w-[100%]'>Name : </span>{item.name}</p>
                                        <p> <span className='text-[#000] font-bold'>Language Code : </span>{item.language}</p>
                                        <p> <span className='text-[#000] font-bold'>Channel : </span>{item.channel || '--'}</p>
                                    </td>
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] truncate max-w-[200px] whitespace-nowrap overflow-hidden text-ellipsis">
                                        {getFirstComponentText(item)}
                                    </td>
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6]">
                                        <p className='text-[#3fca90] flex'>{item.category}</p>
                                        <p className='text-[#3fca90] flex items-center '>  
                                            {item.status && (item.status === 'APPROVED' || item.status === "Approved") ? <HiCheckCircle className='text-[#3fca90]' /> : <HiCheckCircle className='text-[#ed5050]' />} {item.status}
                                        </p>
                                    </td>
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] text-start">
                                        <p>
                                            <span className='text-[#000] font-bold w-[100%]'>Created : </span>
                                            {formatDate(item.created_at)}
                                        </p>
                                        <p>
                                            <span className='text-[#000] font-bold'>Modified : </span>
                                            {formatDate(item.updated_at)}
                                        </p>
                                    </td>
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6]">
                                        <button
                                            onClick={() => {
                                                setOpenApipayload(true);
                                                getApipayload(item.id);
                                            }}
                                            className='hover:bg-[#316bb0] text-[#316bb0] px-2 py-1 rounded-md hover:text-[#fff] flex items-center gap-1 text-[12px] border-[1px] border-[#316bb0]'>
                                            <MdRemoveRedEye /> View
                                        </button>
                                    </td>
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6] ">
                                        <div className='w-[100%] flex items-center gap-2'>
                                            <button
                                                onClick={() => {
                                                    setopenTemplatePreview(true);
                                                    getText(item.id);
                                                }}
                                                className='p-1 border-[1px] border-[#316bb0] rounded-md text-[#316bb0] hover:text-[#fff] hover:bg-[#316bb0]'><MdRemoveRedEye /></button>
                                            <button
                                                onClick={() => {
                                                    setopenCampainModal(true);
                                                }}
                                                className='p-1 border-[1px] border-[#448c74] rounded-md text-[#448c74] hover:text-[#fff] hover:bg-[#448c74]'><FaPaperPlane />
                                            </button>
                                            <button
                                                onClick={() => {
                                                    setidfordelete(item.id);
                                                    setopenDeleteModal(true);
                                                }}
                                                className='p-1 border-[1px] border-[#ed5050] rounded-md text-[#ed5050] hover:text-[#fff] hover:bg-[#ed5050]'><MdDelete /></button>
                                            <button
                                                onClick={() => {
                                                    const text = getUrl(item.id)
                                                    handletext(text,item.name);
                                                }}
                                                className='p-1 border-[1px] border-[#448c74] rounded-md text-[#448c74] hover:text-[#fff] hover:bg-[#448c74]'><FiEdit /></button>
                                            <button
                                                 onClick={retrieveMetaTemplates}
                                                className='p-1 border-[1px] border-[#121519] rounded-md text-[#121519] hover:text-[#fff] hover:bg-[#121519]'><LuRefreshCcw /></button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" className="p-2 text-center text-gray-500">
                                    No data found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                <Pagination currentPage={page} pageCount={pageCount} setPage={setPage} />
            </div>

            <InsightsModal isOpen={open} onClose={() => setopen(false)} heading={'Template Insights'}>
                <div className='w-[100%] border-t-[1px] border-[#e3e9ef] mt-3 flex item-center  flex-wrap gap-2 justify-between p-2'>
                    <div className='flex items-center gap-2' >
                        <div className='bg-[#00816a] flex items-center justify-center p-3 rounded-md text-[#fff]'>
                            <FaBullhorn />
                        </div>
                        <div>
                            <p className='text-[#000] text-[14px] font-bold'>Test</p>
                            <p className='text-[#3fca90] text-[14px] font-bold'>Action</p>
                        </div>
                    </div>
                    <div>
                        <span className='text-[#414040] text-[14px] font-semibold'>Auto-detected:</span>
                    </div>
                    <div className="relative">
                        {/* Custom Select Button */}
                        <div
                            onClick={() => setOpenDropdown(!openDropdown)}
                            className="p-2 border border-[#e3e9ef] rounded-lg cursor-pointer"
                        >
                            {Daterange === "custom" ? customLabel : `Past ${Daterange} days`}
                        </div>
                        {/* Dropdown */}
                        {openDropdown && (
                            <div className="absolute w-full bg-white border border-[#e3e9ef] rounded-lg mt-1 z-50">
                                <div
                                    className="p-2 hover:bg-gray-100 cursor-pointer"
                                    onClick={() => {
                                        setDaterange("7");
                                        setOpenDropdown(false);
                                        setShowPicker(false);
                                    }}
                                >
                                    Past 7 days
                                </div>
                                <div
                                    className="p-2 hover:bg-gray-100 cursor-pointer"
                                    onClick={() => {
                                        setDaterange("30");
                                        setOpenDropdown(false);
                                        setShowPicker(false);
                                    }}
                                >
                                    Past 30 days
                                </div>
                                <div
                                    className="p-2 hover:bg-gray-100 cursor-pointer"
                                    onClick={() => {
                                        setDaterange("90");
                                        setOpenDropdown(false);
                                        setShowPicker(false);
                                    }}
                                >
                                    Past 90 days
                                </div>
                                {/* Custom */}
                                <div
                                    className="p-2 hover:bg-gray-100 cursor-pointer"
                                    onClick={() => {
                                        setDaterange("custom");
                                        setShowPicker(true);
                                    }}
                                >
                                    {customLabel}
                                </div>
                            </div>
                        )}
                        {/* Date Picker */}
                        {showPicker && (
                            <div className="absolute right-0 z-50 mt-2">
                                <DateRange
                                    editableDateInputs={true}
                                    onChange={(item) => {
                                        const start = item.selection.startDate;
                                        const end = item.selection.endDate;
                                        const label = `${start.toLocaleDateString()} - ${end.toLocaleDateString()}`;
                                        setCustomLabel(label);
                                        setDaterange("custom");
                                        setShowPicker(false);
                                        setOpenDropdown(false);
                                    }}
                                    moveRangeOnFirstSelection={false}
                                    ranges={state}
                                />
                            </div>
                        )}
                    </div>
                </div>
                <div className='flex flex-col lg:flex-row w-[100%] gap-3'>
                    <div className='w-[100%] md:w-[26%]  p-4 flex flex-col justify-center border-t-[1px] border-[#e3e9ef]  '>
                        <div className='scale-[0.85] origin-top pb-3'>
                            <div
                                className='w-[300px] bg-cover bg-center h-[600px] flex justify-center items-center  '
                                style={{ backgroundImage: `url(${whatsappBgimage})` }}>
                                <div className='w-[266.5px] bg-cover bg-center bg-no-repeat bg-[#efeae2]  h-[570px] rounded-[40px]'
                                    style={{
                                        backgroundImage: `url(${whatsappBodyBgimage})`
                                    }}>
                                    <div className='bg-[#00816a] h-[75px] w-[100%] rounded-t-[20px] ml-[.5px]  relative overflow-hidden  '>
                                        <div className='w-[100%] flex justify-between px-2'>
                                            <div className='flex items-center gap-2 text-[12px] text-[#fff]'>
                                                <span>12:00</span>
                                                <FaWhatsapp />
                                                <FaInstagram />
                                            </div>
                                            <img src={whatsappnotch} alt="" className='w-[100px] h-[20px] object-content mt-[-10px]' />
                                            <div className='flex items-center gap-2 text-[12px] text-[#fff]'>
                                                <FaWifi />
                                                <MdOutlineSignalCellularConnectedNoInternet4Bar />
                                                <MdBatteryFull />
                                            </div>
                                        </div>
                                        <div className='w-[100%] flex px-2 items-center  justify-between py-1 gap-1'>
                                            <div className='flex items-center text-[#fff] gap-1'>
                                                <FaArrowLeftLong className='text-[28px]' />
                                                <img src={Whatsappicon} alt="" className='w-10 h-10' />
                                                <div className='flex flex-col '>
                                                    <span className='text-[12px] text-wrap text-[#fff] font-bold'> {template_name}</span>
                                                    <span className='text-[10px] text-wrap text-[#fff]'>Business Account</span>
                                                </div>
                                            </div>
                                            <div className='flex flex-col gap-1 text-[#fff]'>
                                                <FaShop />
                                                <RxDotsVertical />
                                            </div>
                                        </div>
                                    </div>
                                    <div className=' w-[100%] p-2 h-[500px] flex flex-col items-baseline justify-between'>
                                        <div className='bg-[#fff] w-[90%] p-1 rounded-lg pb-2 '>
                                            <span className='text-[#1a1919] text-[13px]  text-wrap break-words font-bold'></span>
                                            <p style={{ whiteSpace: "pre-line" }} className='text-[#1a1919] text-[12px] font-semibold text-wrap break-words mt-1'>{Datatext}</p>
                                        </div>
                                        <div className='w-[100%] flex justify-between items-center gap-1'>
                                            <div className='bg-[#fff] flex justify-between px-2 py-3 rounded-lg w-[90%]'>
                                                <div className='flex items-center gap-2'>
                                                    <CiFaceSmile />
                                                    <span className='text-[#575656] text-[12px]'>Enter your message</span>
                                                </div>
                                                <div className='flex items-center gap-2 text-[#575656]'>
                                                    <FaPaperclip />
                                                    <FaCamera />
                                                </div>
                                            </div>
                                            <div className='bg-[#448c71] h-[30px] w-[30px] rounded-full flex justify-center items-center text-[#fff]'>
                                                <FaMicrophone />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='w-[100%] md:w-[72%] '>
                        <div className='w-[100%] border-[1px] border-[#e3e9ef] rounded-lg p-2 h-[300px] '>
                            <div className='border-b-[1px] border-[#e3e9ef] pb-3'>
                                <p className='text-[#363636] text-[14px] font-bold'>Performance</p>
                            </div>
                            <div className='flex flex-wrap justify-between w-[100%] py-2'>
                                <div className='md:w-[24%] sm:w-[48%] w-[100%] text-center'>
                                    <h1 className='text-[#000] text-[14px] font-bold' >{0}</h1>
                                    <p className='text-[#727171] text-[14px] font-bold'>Messages Sent</p>
                                </div>
                                <div className='md:w-[24%] sm:w-[48%] w-[100%] text-center'>
                                    <h1 className='text-[#000] text-[14px] font-bold' >{0}</h1>
                                    <p className='text-[#727171] text-[14px] font-bold'>Messages Delivered</p>
                                </div>
                                <div className='md:w-[24%] sm:w-[48%] w-[100%] text-center'>
                                    <h1 className='text-[#000] text-[14px] font-bold' >{0}</h1>
                                    <p className='text-[#727171] text-[14px] font-bold'>Messages Read</p>
                                </div>
                                <div className='md:w-[24%] sm:w-[48%] w-[100%] text-center'>
                                    <h1 className='text-[#000] text-[14px] font-bold' >{0}</h1>
                                    <p className='text-[#727171] text-[14px] font-bold'>Replies</p>
                                </div>
                            </div>
                        </div>
                        <div className='border-[1px] border-[#e3e9ef] rounded-lg p-2 w-[100%] mt-3'>
                            <div className='border-b-[1px] border-[#e3e9ef] pb-4'>
                                <p className='text-[#363636] text-[14px] font-bold'>Button Clicks</p>
                            </div>
                            <div className="w-full overflow-x-auto">
                                <table className="w-full border-collapse">
                                    <thead className="border-b border-gray-300">
                                        <tr className="text-left text-[12px] text-gray-600">
                                            <th className="p-2">Label</th>
                                            <th className="p-2">Type</th>
                                            <th className="p-2">Total Clicks</th>
                                            <th className="p-2">Click Rate</th>
                                        </tr>
                                    </thead>
                                    <tbody className="text-[12px] text-gray-500">
                                        {data.length > 0 ? (
                                            data.map((item, index) => (
                                                <tr
                                                    key={index}
                                                    className="border-b border-gray-200 hover:bg-gray-50"
                                                >
                                                    <td className="p-2">{item.label}</td>
                                                    <td className="p-2">{item.type}</td>
                                                    <td className="p-2">{item.totalClicks}</td>
                                                    <td className="p-2">{item.clickRate}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td
                                                    colSpan="4"
                                                    className="p-3 text-center text-gray-400"
                                                >
                                                    No button clicks found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </InsightsModal>

            <ApiPayloadModal isOpen={OpenApipayload} onClose={() => setOpenApipayload(false)}>
                <div className='w-[100%] p-3 border-l-[4px] border-[#3f7fca] rounded-l-lg'>
                    <h5 className='text-[14px] font-bold text-[#3f7fca]'>Notes:</h5>
                    <ul className="list-disc pl-5 text-[12px] text-gray-500">
                        <li>
                            <span className="text-[#e3116c]">{`{{to}}`}</span> → contains the mobile number where the message will be sent.
                        </li>
                        <li>
                            <span className="text-[#e3116c]">{`{{1}}, {{2}}, ...`}</span> → replace these in body parameters with actual dynamic values.
                        </li>
                        <li>
                            <span className="text-[#e3116c]">{`{{1}}`}</span> (in header) → used when header contains media (image, video, or document) — replace with media URL.
                        </li>
                        <li>
                            <span className="text-[#e3116c]">{`{{url}}`}</span> → replace with the actual link for URL buttons.
                        </li>
                    </ul>
                </div>
                <div className='w-[100%] flex justify-between mt-4 '>
                    <span className="text-[16px] font-semibold dark:text-white">
                        Template JSON
                    </span>
                    <button
                        onClick={handleCopy}
                        className='flex items-center gap-2 border-[1px] border-[#d7dde2] p-2 text-[12px] rounded-md mr-2'> <FaCopy />
                        Copy Json
                    </button>
                </div>
                <div className='bg-[#f8f9fa] text-[#212529] p-2 m-2' >
                    <pre className='text-[12px]'>{JSON.stringify(Apipayload, null, 2)}</pre>
                </div>
            </ApiPayloadModal>

            <TemplatePreview isOpen={openTemplatePreview} onClose={() => setopenTemplatePreview(false)}>
                <div className='w-[100%] md:w-[26%]  p-4 flex flex-col justify-center    border-t-[1px] border-[#e3e9ef]  '>
                    <div className='scale-[0.85] origin-top pb-3'>
                        <div
                            className='w-[300px] bg-cover bg-center h-[600px] flex justify-center items-center  '
                            style={{ backgroundImage: `url(${whatsappBgimage})` }}>
                            <div className='w-[266.5px] bg-cover bg-center bg-no-repeat bg-[#efeae2]  h-[570px] rounded-[40px]    '
                                style={{
                                    backgroundImage: `url(${whatsappBodyBgimage})`
                                }}>
                                <div className='bg-[#00816a] h-[75px] w-[100%] rounded-t-[20px] ml-[.5px]  relative overflow-hidden  '>
                                    <div className='w-[100%] flex justify-between px-2'>
                                        <div className='flex items-center gap-2 text-[12px] text-[#fff]'>
                                            <span>12:00</span>
                                            <FaWhatsapp />
                                            <FaInstagram />
                                        </div>
                                        <img src={whatsappnotch} alt="" className='w-[100px] h-[20px] object-content mt-[-10px] ' />
                                        <div className='flex items-center gap-2 text-[12px] text-[#fff]'>
                                            <FaWifi />
                                            <MdOutlineSignalCellularConnectedNoInternet4Bar />
                                            <MdBatteryFull />
                                        </div>
                                    </div>
                                    <div className='w-[100%] flex px-2 items-center  justify-between py-1 gap-1'>
                                        <div className='flex items-center text-[#fff] gap-1'>
                                            <FaArrowLeftLong className='text-[28px]' />
                                            <img src={Whatsappicon} alt="" className='w-10 h-10' />
                                            <div className='flex flex-col '>
                                                <span className='text-[12px] text-wrap text-[#fff] font-bold'> {template_name}</span>
                                                <span className='text-[10px] text-wrap text-[#fff]'>Business Account</span>
                                            </div>
                                        </div>
                                        <div className='flex flex-col gap-1 text-[#fff]'>
                                            <FaShop />
                                            <RxDotsVertical />
                                        </div>
                                    </div>
                                </div>
                                <div className=' w-[100%] p-2 h-[500px] flex flex-col items-baseline justify-between'>
                                    <div className='bg-[#fff] w-[90%] p-1 rounded-lg pb-2 '>
                                        <span className='text-[#1a1919] text-[13px]  text-wrap break-words font-bold'>{ }</span>
                                        <p style={{ whiteSpace: "pre-line" }} className='text-[#1a1919] text-[12px] font-semibold text-wrap break-words mt-1'>{Datatext}</p>
                                    </div>
                                    <div className='w-[100%] flex justify-between items-center gap-1'>
                                        <div className='bg-[#fff] flex justify-between px-2 py-3 rounded-lg w-[90%]'>
                                            <div className='flex items-center gap-2'>
                                                <CiFaceSmile />
                                                <span className='text-[#575656] text-[12px]'>Enter your message</span>
                                            </div>
                                            <div className='flex items-center gap-2 text-[#575656]'>
                                                <FaPaperclip />
                                                <FaCamera />
                                            </div>
                                        </div>
                                        <div className='bg-[#448c71] h-[30px] w-[30px] rounded-full flex justify-center items-center text-[#fff]'>
                                            <FaMicrophone />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </TemplatePreview>

            <CampaignModal isOpen={openCampainModal} onClose={() => setopenCampainModal(false)} onConfirm >
            </CampaignModal>

            <SyncModal isOpen={openSyncModal} onClose={() => setopenSyncModal(false)}>
            </SyncModal>

            <DeleteModal isOpen={openDeleteModal} onClose={() => setopenDeleteModal(false)}
                onConfirm={() => {
                    Deleteitem(idfordelete);
                    setopenDeleteModal(false)
                    setidfordelete(null)
                }}
            >
            </DeleteModal>
        </>
    )
}
export default WhatsAppTemplates
